import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["anchor"]

  connect() {
    this.scrollToAnchor("auto")

    this._handler = (event) => {
      if (this.eventTargetsOwnSubtree(event)) this.scrollIfNearBottom()
    }

    document.addEventListener("turbo:frame-load", this._handler)
    document.addEventListener("turbo:frame-render", this._handler)
    document.addEventListener("turbo:before-stream-render", this._handler)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this._handler)
    document.removeEventListener("turbo:frame-render", this._handler)
    document.removeEventListener("turbo:before-stream-render", this._handler)
  }

  eventTargetsOwnSubtree(event) {
    const candidates = []
    if (event.target instanceof Element) candidates.push(event.target)
    const streamTargets = event.target?.targetElements
    if (Array.isArray(streamTargets)) candidates.push(...streamTargets)
    return candidates.some((el) => el && this.element.contains(el))
  }

  scrollToAnchor(scrollBehavior = "auto") {
    const container = this.element
    container.scrollTo({ top: container.scrollHeight, behavior: scrollBehavior })
  }

  scrollIfNearBottom() {
    const container = this.element
    const threshold = 120
    const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight

    if (distanceFromBottom <= threshold) {
      this.scrollToAnchor()
    }
  }
}